import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header  from './Header';
import './MainLayout.css';

const MainLayout = ({ children, pageTitle, pageSubtitle }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={`layout${collapsed ? ' layout-collapsed' : ''}`}>
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <div className="layout-body">
        <Header collapsed={collapsed} pageTitle={pageTitle} pageSubtitle={pageSubtitle} />
        <main className="layout-main">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
